import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import icons from "../constants/icons";
import images from "../constants/images";

const Header = () => {
  const mobSearchRef = useRef();

  const navigate = useNavigate();

  const handleSearch = (search) => {
    navigate(`/search/${search}`, { replace: true });
  };

  // useEffect(() => {
  //   sidebarRef && sidebarRef.current.classList.remove("show-sidebar");
  // }, [sidebarRef, router]);

  return (
    <>
      <div className="header">
        <img
          src={icons.menu}
          className="menu-icon"
          // onClick={() => {
          //   sidebarRef.current.classList.toggle("show-sidebar");
          // }}
        />

        <Link to="/">
          <img src={images.logo} className="logo" />
        </Link>

        <nav>
          <Link to="/">Home</Link>
          <Link to="/dmca">DMCA</Link>
          <Link to="/about">ABOUT</Link>
          <Link to="/contact">CONTACT</Link>
        </nav>

        {/* <Image
          src={icons.search}
          className="search-ico"
          onClick={() => {
            mobSearchRef.current.classList.toggle("show");
          }}
        /> */}
        <div className="search-ico" />

        {/* <div className="search">
          <input
            placeholder="Search..."
            className="input"
            onChange={(e) => handleSearch(e.currentTarget.value)}
          />
          <Image
            src={icons.search}
            className="search-icon"
            // onClick={handleSearch}
          />
        </div> */}
      </div>

      <div className="mobile" ref={mobSearchRef}>
        <input
          placeholder="Search..."
          onChange={(e) => handleSearch(e.currentTarget.value)}
        />
      </div>

      {/* <div className="sidebar" ref={sidebarRef}>
        {[...categories].map((item, index) => (
          <Link
            href={`/category/${item?.link || item?.title}`.toLowerCase()}
            className="categories"
            key={index}
          >
            {item.title}
          </Link>
        ))}
      </div> */}
    </>
  );
};

export default Header;
